import React from 'react'

function TerpsPublish() {
  return (
    <div>TerpsPublish</div>
  )
}

export default TerpsPublish